var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 738,
    viewBox: "0 0 725 738",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 726,
    height: 738,
    fill: "url(#paint0_linear_1_980)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.03 363.519C617.87 359.659 615.27 354.149 615.27 348.029C615.27 341.909 617.87 336.409 622.03 332.549C623.15 331.509 624.39 330.589 625.72 329.809C629.88 325.949 632.48 320.439 632.48 314.319C632.48 302.649 623.01 293.189 611.32 293.189C599.63 293.189 590.17 302.649 590.17 314.319C590.17 320.439 592.77 325.949 596.93 329.809C598.26 330.589 599.49 331.509 600.62 332.549C604.78 336.409 607.39 341.919 607.39 348.029C607.39 354.139 604.79 359.659 600.62 363.519C599.5 364.559 598.26 365.479 596.93 366.259C592.77 370.119 590.17 375.629 590.17 381.749C590.17 393.419 599.64 402.879 611.32 402.879C623 402.879 632.48 393.419 632.48 381.749C632.48 375.629 629.88 370.119 625.72 366.259C624.39 365.479 623.15 364.559 622.03 363.519Z",
    fill: "#5A03EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.94 267.36C541.1 271.22 543.7 276.73 543.7 282.85C543.7 288.97 541.1 294.48 536.94 298.34C535.82 299.38 534.58 300.3 533.25 301.08C529.09 304.94 526.49 310.45 526.49 316.57C526.49 328.24 535.96 337.7 547.64 337.7C559.32 337.7 568.8 328.24 568.8 316.57C568.8 310.45 566.2 304.94 562.04 301.08C560.71 300.3 559.48 299.38 558.36 298.34C554.2 294.48 551.59 288.97 551.59 282.85C551.59 276.73 554.19 271.22 558.36 267.36C559.48 266.32 560.71 265.4 562.04 264.62C566.2 260.76 568.8 255.25 568.8 249.13C568.8 237.46 559.33 228 547.64 228C535.95 228 526.49 237.46 526.49 249.13C526.49 255.25 529.09 260.76 533.25 264.62C534.58 265.4 535.82 266.32 536.94 267.36Z",
    fill: "#004BEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.651 363.519C490.491 359.659 487.891 354.149 487.891 348.029C487.891 341.909 490.491 336.409 494.651 332.549C495.771 331.509 497.011 330.589 498.341 329.809C502.501 325.949 505.101 320.439 505.101 314.319C505.101 302.649 495.631 293.189 483.941 293.189C472.251 293.189 462.791 302.649 462.791 314.319C462.791 320.439 465.391 325.949 469.551 329.809C470.881 330.589 472.121 331.509 473.241 332.549C477.401 336.409 480.001 341.919 480.001 348.029C480.001 354.139 477.401 359.659 473.241 363.519C472.121 364.559 470.881 365.479 469.551 366.259C465.391 370.119 462.791 375.629 462.791 381.749C462.791 393.419 472.261 402.879 483.941 402.879C495.621 402.879 505.101 393.419 505.101 381.749C505.101 375.629 502.501 370.119 498.341 366.259C497.011 365.479 495.771 364.559 494.651 363.519Z",
    fill: "#5A03EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.34 428.709C554.18 424.849 551.57 419.339 551.57 413.219C551.57 407.099 554.17 401.589 558.34 397.729C559.46 396.689 560.7 395.769 562.03 394.989C566.19 391.129 568.79 385.619 568.79 379.499C568.79 367.829 559.32 358.369 547.63 358.369C535.94 358.369 526.48 367.829 526.48 379.499C526.48 385.619 529.08 391.129 533.24 394.989C534.57 395.769 535.8 396.689 536.93 397.729C541.09 401.589 543.69 407.099 543.69 413.219C543.69 419.339 541.09 424.849 536.93 428.709C535.81 429.749 534.57 430.669 533.24 431.449C529.08 435.309 526.48 440.819 526.48 446.939C526.48 458.609 535.95 468.069 547.63 468.069C559.31 468.069 568.79 458.609 568.79 446.939C568.79 440.819 566.19 435.319 562.03 431.449C560.7 430.669 559.46 429.749 558.34 428.709Z",
    fill: "#004BEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.16 326.9C432.84 326.9 442.31 336.36 442.31 348.03C442.31 359.7 432.84 369.16 421.16 369.16C409.48 369.16 400 359.7 400 348.03C400 336.36 409.47 326.9 421.16 326.9Z",
    fill: "#008AED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.121 326.9C685.801 326.9 695.271 336.36 695.271 348.03C695.271 359.7 685.801 369.16 674.121 369.16C662.441 369.16 652.961 359.7 652.961 348.03C652.961 336.36 662.431 326.9 674.121 326.9Z",
    fill: "#008AED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_980",
    x1: 2.50002,
    y1: 738,
    x2: 720,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A03EE",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/Logo_BG.9c59518dd51b2165470c10e39a5371af.svg";
export { ForwardRef as ReactComponent };